import StyledComponent from 'styled-components';

const AppContainer = StyledComponent.div`
  .app-wrapper
  {
    min-height: 100%;
    height: auto !important;
    height: 100%;
    background: #F5F5F5;
  }

  .pane-holder
  {
      margin-top: 0px;
      max-width:  100%;
      margin-top: 10px;
      display:    flex;
      flex-direction: row;
      padding-bottom: 80px;
      @media only screen and (max-width: 992px)
      {
        flex-direction: column;
      }
  }
  .left-pane
  {
      text-align: left;
      display: flex;
      flex-direction: column;

        width: 15%;
        float: left;
        margin-left: 1%;
  }

  .center-pane
  {
      display:flex;
      margin-left: 2%;
      margin-right: 2%;
      flex-direction:column;
      float: right;
      border-radius: 4px;

      @media only screen and (max-width: 992px) and (min-width: 601px)
      {
        margin-top: 2%;
        margin-left: auto;
        margin-right: auto;
      }
      @media only screen and (max-width: 600px)
      {
        width:100% !important;
        margin-left: 0%;
        margin-right: 0%;
      }
  }
  .center-pane-80
  {
    width: 80%;
  }
  .center-pane-100
  {
    width: 100%;
  }

  .full-width:
  {
    width: 100% !important;
  }

  text-align:         center;
  background-color:   #FFFFFF;
  width:              100%;
  position:           absolute !important;
  top:                0px;
  bottom:             0;

  @media only screen and (max-width: 992px)
  {
    position: relative;
  }
  `;

export {
  AppContainer
};